export { Level, liveAnnounce, liveAnnounceId } from '../live-announce/index.esm.js';
export { ResolutionStrategy, ScriptLoader, checkScriptIsLoaded, documentHead, loadScript } from '../script-loader/index.esm.js';
export { EGDSContext, EGDSContextProvider, EGDSContextWrapper, useEGDSContext } from '../context-provider/index.esm.js';
import 'react';
export { useIdCompatibility } from '../use-id-compatibility/index.esm.js';
import 'react/jsx-runtime';
import 'react-swipeable';
if (typeof document !== 'undefined') {
  // Detect iOS devices
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window);
  const addBodyClass = () => {
    if (isIOS) return; // Do nothing on iOS
    if (!document.body.classList.contains('uitk-no-outline')) {
      document.body.classList.add('uitk-no-outline');
      // Manage event listeners
      document.body.removeEventListener('mousedown', addBodyClass);
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      document.body.addEventListener('keydown', removeBodyClass);
    }
  };
  const removeBodyClass = () => {
    if (isIOS) return; // Do nothing on iOS
    if (document.body.classList.contains('uitk-no-outline')) {
      document.body.classList.remove('uitk-no-outline');
      // Manage event listeners
      document.body.removeEventListener('keydown', removeBodyClass);
      document.body.addEventListener('mousedown', addBodyClass);
    }
  };
  // Auto-initialize (only if not iOS)
  if (!isIOS) addBodyClass();
}